import chatimeImage from '../assets/icon/icon-1.png';
import sodexoImage from '../assets/icon/icon-2.png';
import vacherinImage from '../assets/icon/icon-3.png';
import boxedImage from '../assets/icon/icon-4.png';
import breazImage from '../assets/icon/icon-5.png';
import lexEatsImage from '../assets/icon/icon-6.png';
import pearPayImage from '../assets/icon/icon-7.png';
import canteenImage from '../assets/icon/icon-8.png';
import sandboxImage from '../assets/icon/icon-9.png';
import atalianImage from '../assets/icon/icon-10.png';
import lantanaImage from '../assets/icon/icon-11.png';
import amexImage from '../assets/icon/icon-12.png';
import threeImage from '../assets/icon/icon-13.png';
import sonyKitchenImage from '../assets/icon/icon-14.png';
import refuelImage from '../assets/icon/icon-15.png';
import jpmcImage from '../assets/icon/icon-16.png';

export const statuses = ["PREPARING", "READY"];

const partnersData = [
    {
        applicationId: 1,
        partnerId: 4,
        logoChoice: false,
        image: chatimeImage,
        appStore: 'https://apps.apple.com/gb/app/chatime-uk/id1225902100',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.chatime',
        website: 'https://chatime.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Chatime UK: Pickup & Delivery' app"
    },
    {
        applicationId: 2,
        partnerId: 9,
        logoChoice: false,
        image: sodexoImage,
        appStore: 'https://apps.apple.com/gb/app/twelve-by-sodexo/id1338702323',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sodexo&hl=en_GB',
        website: 'https://twelve.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Everyday' app"
    },
    {
        applicationId: 3,
        partnerId: 10,
        logoChoice: false,
        image: vacherinImage,
        appStore: 'https://apps.apple.com/gb/app/vacherin-catering/id1437423714',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.vacherin',
        website: 'https://vacherin.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Vacherin Catering' app"
    },
    {
        applicationId: 4,
        partnerId: 10,
        logoChoice: true,
        image: boxedImage,
        appStore: 'https://apps.apple.com/gb/app/boxed-app/id1518041487',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.chco',
        website: 'https://boxed.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Boxed' app"
    },
    {
        applicationId: 5,
        partnerId: 11,
        logoChoice: false,
        image: breazImage,
        image2: lexEatsImage,
        appStore: 'https://apps.apple.com/us/app/breaz/id1486594552',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.elior',
        website: 'https://breaz.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Breaz' app"
    },
    {
        applicationId: 6,
        partnerId: 11,
        logoChoice: true,
        image: lexEatsImage,
        appStore: 'https://apps.apple.com/gb/app/lexeat/id1195558110',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.lexington',
        website: 'https://lexeats.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'LexEats' app"
    },
    {
        applicationId: 9,
        partnerId: 12,
        logoChoice: false,
        image: sandboxImage,
        appStore: 'https://apps.apple.com/gb/app/dynamify-sandbox/id1511167977',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sandbox',
        website: 'https://www.sandbox.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the app"
    },
    {
        applicationId: 7,
        partnerId: 13,
        logoChoice: false,
        image: pearPayImage,
        appStore: 'https://apps.apple.com/gb/app/pearpay/id1511733597',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.bartlettmitchell',
        website: 'https://pearpay.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'PearPay' app"
    },
    {
        applicationId: 8,
        partnerId: 13,
        logoChoice: true,
        image: canteenImage,
        appStore: 'https://apps.apple.com/gb/app/canteen/id1579691205',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.five',
        website: 'https://canteen.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Canteen' app"
    },
    {
        applicationId: 14,
        partnerId: 13,
        logoChoice: true,
        image: sonyKitchenImage,
        appStore: 'https://apps.apple.com/gb/app/sonykitchen/id1621588998',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sonykitch',
        website: 'https://sonykitchen.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Sony Kitchen' app"
    },
    {
        applicationId: 10,
        partnerId: 14,
        logoChoice: false,
        image: atalianImage,
        appStore: 'https://apps.apple.com/gb/app/angel-hill/id1512795493',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.angelfood',
        website: 'https://atalianservest.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Atalian Servest' app"
    },
    {
        applicationId: 11,
        partnerId: 15,
        logoChoice: false,
        image: lantanaImage,
        appStore: 'https://apps.apple.com/gb/app/lantana/id1572863371',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.lantana',
        website: 'https://lantana.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Lantana Residencies' app"
    },
    {
        applicationId: 12,
        partnerId: 16,
        logoChoice: false,
        image: amexImage,
        appStore: 'https://apps.apple.com/gb/app/food2you-at-amex/id1572863041',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.amex',
        website: 'https://amex.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Food2You' app"
    },
    {
        applicationId: 13,
        partnerId: 17,
        logoChoice: false,
        image: threeImage,
        appStore: 'https://apps.apple.com/gb/app/food-at-three/id1606911449',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.three',
        website: 'https://3.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Food @ Three' app"
    },
    {
        applicationId: 15,
        partnerId: 18,
        logoChoice: false,
        image: refuelImage,
        appStore: 'https://apps.apple.com/gb/app/refuel/id6446634031',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.iss',
        website: 'https://refuel.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'Refuel: Make Life Easier' app"
    },
    {
        applicationId: 16,
        partnerId: 19,
        logoChoice: false,
        image: jpmcImage,
        appStore: 'https://apps.apple.com/gb/app/efeed/id6446634916',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.jpmc',
        website: 'https://efeed.dynamify.com',
        text: "Skip the lines and earn rewards when you order & pay through the 'efeed' app"
    },
];


// export const parseURLBuildingId = () => {
//     const params = new URL(window.location.href).searchParams;
//     return (params.get('buildingId') || '');
// };
// export const parseURLUserId = () => {
//     const params = new URL(window.location.href).searchParams;
//     return (params.get('userId') || '');
// };
export const parseURLuid = () => {
    const params = new URL(window.location.href).searchParams;
    return (params.get('uid') || '');
};


export const getOrderStatusSettings = async (uid) => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/order-status?uid=${uid}&key=${process.env.REACT_APP_KEY}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(data => {return data.json()}).catch()
};

export const setPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--primaryColour', '#' + color);
};
export const setPreparingPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--preparingPrimaryColour', '#' + color);
};
export const setCompletedPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--completedPrimaryColour', '#' + color);
};
export const setFontFamily = (font) => {
    document.documentElement.style.setProperty('--font-family', font);
};

export const getPartnerData = (partnerId = 12, logoChoice = false) => {
    return partnersData.find(partnersData => partnersData.partnerId === partnerId && partnersData.logoChoice === logoChoice);
};

// export const getApplicationData = (applicationId = 9) => {
//     return partnersData.find(partnersData => partnersData.applicationId === applicationId);
// };

// export const loginUsers = async (credentials) => {
//     return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/login`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// };

// export const logoutUsers = async (token) => {
//     return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/logout`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-Auth-Token': token
//         }
//     })
//         .then((response) => {
//             return response;
//         })
//         .then(() => {
//             return true;
//         })
//         .catch((error) => {
//             throw new Error(error);
//         });
// };

export const customerDetails = async (tradeIdArray = [], storeIds = '') => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/trade/customerDetails?filler=true&key=${process.env.REACT_APP_KEY}` +
        (tradeIdArray.length > 0 ? `&tradeIds=${tradeIdArray.join(',')}` : ``) +
        (storeIds.length > 0 ? `&storeIds=${storeIds.join(',')}` : ``), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(data => {return data.json()}).catch()
};
// export const listStores = async (token) => {
//     return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/stores-list`, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-Auth-Token': token
//         },
//     }).then((response) => response.json())
//         .then((result) => {
//             return result;
//         })
//         .catch((error) => {
//             throw new Error(error);
//         });
// };


export const setLocalOrderStatusSettings = (orderStatusSettings) => {
    localStorage.setItem("orderStatusSettings", JSON.stringify(orderStatusSettings));
};
// export const getLocalOrderStatusSettings = () => {
//     const localOrderStatusSettings = localStorage.getItem("orderStatusSettings");
//     return localOrderStatusSettings ? JSON.parse(localOrderStatusSettings) : null;
// };
export const getLocalUserInfoLocalStorage = () => {
    const orderStatusSettings = localStorage.getItem("orderStatusSettings") || '';
    let params = {};
    if (orderStatusSettings !== '') {
        params = JSON.parse(orderStatusSettings);
        const buildingId = (params['buildingId'] || '');
        const storeIds = (params['storeIds'] || '').split(',');
        const storeNames = (params['storeNames'] || '').split(',');
        // const color = params['color'].replace("#", "") || 'ffffff';
        const primaryColour = params['primaryColour'].replace("#", "") || '000506';
        const preparingPrimaryColour = params['preparingPrimaryColour'].replace("#", "") || 'fcb42e';
        const completedPrimaryColour = params['completedPrimaryColour'].replace("#", "") || '67ec67';
        let font = params['font'] || '\'Nunito\', sans-serif';
        if (font.indexOf("TT Norms") > -1) {
            font = '\'Nunito\', sans-serif';
        }
        const showCustomerId = (params['customerId'] || false).toString().toLowerCase() === 'true';
        const showCustomerFirstName = (params['customerFirstName'] || false).toString().toLowerCase() === 'true';
        const showCustomerLastName = (params['customerLastName'] || false).toString().toLowerCase() === 'true';
        const showStoreName = (params['storeName'] || false).toString().toLowerCase() === 'true';
        const showWaitTime = (params['showWaitTime'] || false).toString().toLowerCase() === 'true';
        const peopleAhead = (params['peopleAhead'] || false).toString().toLowerCase() === 'true';
        const logoChoice = (params['logoChoice'] || false).toString().toLowerCase() === 'true';
        const showLoyalty = (params['loyalty'] || false).toString().toLowerCase() === 'true';
        const applicationId = !isNaN(Number(params['applicationId'] || 9)) ? Number(params['applicationId']) : 9;
        const partnerId = !isNaN(Number(params['partnerId'] || 12)) ? Number(params['partnerId']) : 12;
        const subIds = (params['subIds'] || '') ? (params['subIds'] || '').split(',') : [];
        const landScape = params['landScape'] || false;
        const showLogo = params['showLogo'] || false;
        const showDownload = params['showDownload'] != null ? params['showDownload'] : true;
        let logoURL = params['photoFilename'] || '';
        if (logoURL) {
            logoURL = 'https://images.dynamify.com/order-status-logos/' + logoURL;
        }
        return {
            storeIds, primaryColour, preparingPrimaryColour, completedPrimaryColour,
            font, storeNames, showStoreName, showCustomerId, showCustomerFirstName, showCustomerLastName,
            showWaitTime, peopleAhead, applicationId, partnerId, logoChoice,
            subIds, buildingId, landScape, showLogo, showDownload, logoURL, showLoyalty,
        };
    } else {
        params = new URL(window.location.href).searchParams;
        const storeIds = (params.get('storeIds') || '').split(',');
        const storeNames = (params.get('storeNames') || '').split(',');
        const color = params.get('color') || 'ffffff';
        const primaryColour = params.get('primaryColour') || '000506';
        const preparingPrimaryColour = params.get('preparingPrimaryColour') || 'fcb42e';
        const completedPrimaryColour = params.get('completedPrimaryColour') || '67ec67';
        let font = params.get('font') || '\'Nunito\', sans-serif';
        if (font.indexOf("TT Norms") > -1) {
            font = '\'Nunito\', sans-serif';
        }
        const showCustomerId = (params.get('showCustomerId') || false).toString().toLowerCase() === 'true';
        const showCustomerFirstName = (params.get('showCustomerFirstName') || false).toString().toLowerCase() === 'true'; 
        const showCustomerLastName = (params.get('showCustomerLastName') || false).toString().toLowerCase() === 'true';
        const showStoreName = (params.get('showStoreName') || false).toString().toLowerCase() === 'true';
        const showWaitTime = (params.get('showWaitTime') || false).toString().toLowerCase() === 'true';
        const showLoyalty = (params.get('loyalty') || false).toString().toLowerCase() === 'true';
        const peopleAhead = (params.get('peopleAhead') || false).toString().toLowerCase() === 'true';
        const logoChoice = (params.get('logoChoice') || false).toString().toLowerCase() === 'true';
        const applicationId = !isNaN(Number(params['applicationId'] || 9)) ? Number(params['applicationId']) : 9;
        const partnerId = !isNaN(Number(params.get('partnerId') || 12)) ? Number(params.get('partnerId')) : 12;
        const subIds = (params.get('subIds') || '') ? (params.get('subIds') || '').split(',') : [];
        const showLogo = params.get('showLogo') || false;
        let showDownload = true;
        if (params.get('showDownload') != null && params.get('showDownload') === 'false') {
            showDownload = false;
        }
        const logoURL = params.get('logoUrl') || '';
        return {
            storeIds, color, primaryColour, preparingPrimaryColour, completedPrimaryColour,
            font, storeNames, showStoreName, showCustomerId, showCustomerFirstName, showCustomerLastName,
            showWaitTime, showLoyalty, peopleAhead, applicationId, partnerId, logoChoice,
            subIds, showDownload, logoURL, showLogo
        };
    }

};

export const listTrades = async (storeId) => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/trades/order-status?storeId=` + storeId + `&key=${process.env.REACT_APP_KEY}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json())
        .then((result) => {
            return result;
        })
        .catch((error) => {
            throw new Error(error);
        });
};

